module.exports = __webpack_public_path__ + "img/ic_plus.84e421a3.svg";